// extracted by mini-css-extract-plugin
export default {"home_page_container":"HomePage_home_page_container__RUJQO"};